import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IApprovalRoutingRepository } from '../../../business-logic/interfaces/IApprovalRoutingRepository'

interface IDependency {
  httpClient: IHttpClient
}

export class ApprovalRoutingRepository implements IApprovalRoutingRepository {
  constructor(private readonly deps: IDependency) {}

  async setApprovalGroupIsPooled(
    groupId: number,
    isPooled: boolean
  ): Promise<void> {
    try {
      await this.deps.httpClient.patch<
        void,
        {
          is_pooled: boolean
        }
      >(`/api/v3/approval/groups/${groupId}/`, {
        is_pooled: isPooled,
      })

      return
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
